import { User, Batch } from "../../_models";
import { LessonPlan } from "./../../_models/lesson-plan";
// import { ApiService } from './../../_services/api.service';
import { first } from "rxjs/operators";
// import { AuthenticationService, UserService, BatchService, LessonPlanService, AttendanceService, DialogService, CONNECTION_ERROR_MSG } from 'src/app/_services';
// import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
// import { faArrowLeft, faCaretSquareDown } from '@fortawesome/free-solid-svg-icons';
import { ModalBatchPicker } from "../modal-batch-picker";
// import { ngxLoadingAnimationTypes } from 'ngx-loading';
import { ModalLessonplanSlotPicker } from "../modal-lessonplan-slot-picker";
import AuthenticationService from "../../_services/AuthenticationService";
import ApiService from "../../_services/ApiService";
import BatchService from "../../_services/BatchService";
import LessonPlanService from "../../_services/LessonPlanService";
import AttendanceService from "../../_services/AttendanceService";
import DialogService from "../../_services/DialogService";
import { StringLiteralLike } from "typescript";
import React from "react";
import { RouteComponentProps } from "react-router";
import Config from "../../_config/config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faCaretDown, faSync } from "@fortawesome/free-solid-svg-icons";
import PageSpinner from "../../_components/page-spinner/PageSpinner";
import { Modal } from "react-bootstrap";
import { MDBInput, MDBContainer } from "mdbreact";
import { DbService } from "../../_services/DbService";
import notStartedImage from "../../assets/img/not-started.png";

import startedImage from "../../assets/img/started.png";
import completedImage from "../../assets/img/completed.png";
import { AlertDialog } from "../../_components/alert-dialog/AlertDialog";
import StepAnalyticsModal from "../../components/StepAnalyticsModal";

import "./lesson-plan.css";
import { AppPropertiesContext } from "../../contexts/app-properties.context";
import { getAttendanceConfig } from "../../_config/attendance-config";

const PrimaryRed = "#dd0031";
const SecondaryBlue = "#006ddd";

// Map resource type IDs to icons (matches LMBuilder FlipClassResourceCard)
const getResourceIcon = (typeId?: number, url?: string, name?: string): string => {
  if (url) {
    const lowerUrl = url.toLowerCase();
    if (lowerUrl.endsWith(".pdf") || lowerUrl.includes(".pdf?") || lowerUrl.includes("/pdf/")) return "📕";
    if (lowerUrl.includes("youtube.com") || lowerUrl.includes("youtu.be")) return "▶️";
    if (lowerUrl.includes("vimeo.com")) return "🎬";
  }
  if (name) {
    const lowerName = name.toLowerCase();
    if (lowerName.includes("quiz") || lowerName.includes("test") || lowerName.includes("assessment") || lowerName.includes("exam")) return "📋";
  }
  if (!typeId) return "📄";
  const iconMap: { [key: number]: string } = {
    1: "📥", 5: "🔗", 6: "📝", 13: "📚", 16: "🎥", 17: "📋",
    18: "🔗", 19: "📊", 20: "💻", 21: "📄", 22: "🖼️", 23: "🎵",
    25: "📋", 31: "🎬", 32: "▶️", 36: "📋",
  };
  return iconMap[typeId] || "📄";
};

// @Component({
//   selector: 'app-lessonplan',
//   templateUrl: './lessonplan.component.html',
//   styleUrls: ['./lessonplan.component.css']
// })

interface MyProps extends RouteComponentProps {
  my_modal_title?: string;
  my_modal_content?: StringLiteralLike;
  // When true, the page loads lesson plans / step statuses from the nodefork
  // (Node) endpoints instead of the legacy Java sync endpoints, and always
  // bypasses the IndexedDB cache. Used by the /lesson-plan-node route.
  useNode?: boolean;
}

interface MyState {
  loading: boolean;
  showStatusEditModal: boolean;
  StatusEditModalClicked: boolean;
  showMoreOptions: boolean;
  MoreOptionsClicked: boolean;
  editLessonPlanStep: any;
  editLessonPlanStepStatus: any;
  moreOptions: any;
  topics: any;
  selectedActivitySlot: any;
  activitySlots: any;
  batches: Batch[];
  selectedBatch: Batch;
  lesonplans: LessonPlan[];
  lessonplanDetails: any;
  lessonplanSteps: any;
  lessonplanWithOutAttendance: boolean;
  lessonPlanSlotPickerFlag: boolean;
  showAlert: boolean;
  alertMessage: string;
  alertTitle: string;
  batchSlotPicker: boolean;
  showAnalyticsModal: boolean;
  selectedAnalyticsStep: any;
  showResourceActivationModal: boolean;
  activationResults: {
    stepName: string;
    statusName: string;
    totalAssignments: number;
    resourceDetails: Array<{
      id: number;
      name: string;
      tagId: number;
      tagLabel: string;
      type?: string;
      typeId?: number;
      url?: string;
    }>;
  } | null;
  lockedStepIds: Set<number>;
  accessRequestStatuses: Map<number, {
    id: number;
    status: string;
    requestedAt: string;
    reviewedAt: string | null;
    reviewRemarks: string | null;
    unlockExpiresAt: string | null;
  }>;
  showAccessRequestModal: boolean;
  accessRequestStep: any;
  accessRequestReason: string;
  statusDropdownStepId: number | null;
  isFlipClassEnabled: boolean;
  statusTypes: Array<{
    id: number;
    name: string;
    sortOrder: number;
    flipClassConfig: any;
  }>;
}
export class Lessonplan extends React.Component<MyProps, MyState> {
  state: MyState = {
    loading: false,
    showStatusEditModal: false,
    StatusEditModalClicked: false,
    editLessonPlanStep: {},
    editLessonPlanStepStatus: -1,
    showMoreOptions: false,
    MoreOptionsClicked: false,
    moreOptions: [],
    topics: null,
    selectedActivitySlot: null,
    activitySlots: [],
    batches: [],
    selectedBatch: null,
    lesonplans: [],
    lessonplanDetails: {},
    lessonplanSteps: [],
    lessonplanWithOutAttendance: false,
    lessonPlanSlotPickerFlag: false,
    showAlert: false,
    alertMessage: "",
    alertTitle: "ALERT",
    batchSlotPicker: false,
    showAnalyticsModal: false,
    selectedAnalyticsStep: null,
    showResourceActivationModal: false,
    activationResults: null,
    lockedStepIds: new Set<number>(),
    accessRequestStatuses: new Map(),
    showAccessRequestModal: false,
    accessRequestStep: null,
    accessRequestReason: "",
    statusDropdownStepId: null,
    isFlipClassEnabled: false,
    statusTypes: [],
  };
  currentUser: User;
  instructorBatchTopics: any = [];
  closeResult: string;
  errorMessages: any = {};
  todayDate: string;
  lessonplanservice: LessonPlanService = new LessonPlanService();
  batchservice: BatchService = new BatchService();
  dbservice: DbService = new DbService();

  // public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;
  public primaryColour = SecondaryBlue;

  // Never parse `initData` inline — it is absent whenever the Java sync/init
  // call failed, and a null deref here happens during render(), which unmounts
  // the entire React root (no error boundary) and shows a blank page.
  ATTENDANCE_CONFIG = getAttendanceConfig();

  constructor(props: MyProps) {
    super(props);
    this.currentUser = AuthenticationService.currentUserValue;
    this.dbservice.connect().then(() => console.log("dbservice connected"));
  }

  static contextType = AppPropertiesContext;
  context!: React.ContextType<typeof AppPropertiesContext>;

  /**
   * Whether to talk to the nodefork endpoints instead of the legacy Java ones.
   * Either the /lesson-plan-node route asked for it explicitly, or the tenant
   * has no Java backend at all (SynerGen cloud), in which case every Java call
   * from this page would fail and the route choice is not the user's to make.
   */
  useNodeBackend = (): boolean => this.props.useNode || !Config.hasJavaBackend;

  /**
   * Whether to read lesson plans from the IndexedDB cache. In Node mode we
   * always go straight to the API (Node endpoints), bypassing the cache.
   */
  useCacheMethod = (): boolean => {
    if (this.useNodeBackend()) return false;
    const { isUsingCacheMethod } = this.context;
    return isUsingCacheMethod();
  };

  /**
   * Resolve the instructor id to use for sync calls (syncBatches / syncLessonPlans).
   * Admins / non-instructor staff have no currentUser.instructorId, so when this
   * page is opened on behalf of an instructor (e.g. navigated here from the
   * attendance confirmation, which passes the slot via location.state, or via an
   * ?instructorId= query param) we must fall back to that context. Without this,
   * the sync URLs become `.../undefined` and the backend returns 400.
   */
  getEffectiveInstructorId = (): number | undefined => {
    const currentUser = AuthenticationService?.currentUserValue;
    const stateInstructorId = (this.props.location?.state as any)?.instructorId;
    const qpInstructorId = (this as any).queryParams?.instructorId;
    const urlInstructorId = new URLSearchParams(
      this.props.location?.search || "",
    ).get("instructorId");
    return (
      currentUser?.instructorId ||
      stateInstructorId ||
      qpInstructorId ||
      (urlInstructorId ? parseInt(urlInstructorId) : undefined) ||
      undefined
    );
  };

  async fetchStatusTypes() {
    try {
      const response = await ApiService.getLessonPlanStatusTypes();
      if (response.data?.success && response.data?.data) {
        this.setState({ statusTypes: response.data.data });
      }
    } catch (error) {
      console.error("Error fetching lesson plan status types:", error);
      // Fallback to default status types if API fails
      this.setState({
        statusTypes: [
          { id: 1, name: "Not yet started", sortOrder: 1, flipClassConfig: null },
          { id: 4, name: "Warming Up (Pre-class materials released)", sortOrder: 2, flipClassConfig: null },
          { id: 2, name: "Started", sortOrder: 3, flipClassConfig: null },
          { id: 3, name: "Completed", sortOrder: 4, flipClassConfig: null },
        ],
      });
    }
  }

  componentDidMount(): void {
    // Fetch status types first
    this.fetchStatusTypes();


    let today = new Date();
    let dd: any = today.getDate();
    let mm: any = today.getMonth() + 1;
    let yyyy = today.getFullYear();

    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    this.todayDate = dd + "/" + mm + "/" + yyyy;
    console.log("In ngOnInit()..." + JSON.stringify(this.props.location.state));
    console.log("Init Data : <<>> :" + localStorage.getItem("initData"));

    // Check for query parameters first
    const searchParams = new URLSearchParams(this.props.location.search);
    const batchIdParam = searchParams.get('batchId');
    const lessonPlanIdParam = searchParams.get('lessonPlanId');
    const topicIdParam = searchParams.get('topicId');
    const instructorIdParam = searchParams.get('instructorId');
    const activitySlotTemplateIdParam = searchParams.get('activitySlotTemplateId');

    let activitySlotDetails: any = this.props.location.state;

    // If batchId is in query params, use it
    if (batchIdParam) {
      const parsedBatchId = parseInt(batchIdParam);
      const parsedLessonPlanId = lessonPlanIdParam ? parseInt(lessonPlanIdParam) : null;
      const parsedTopicId = topicIdParam ? parseInt(topicIdParam) : null;

      // If we have lessonPlanId, we'll fetch it directly and extract topicId
      if (parsedLessonPlanId) {
        // Store these for later use after we fetch the lesson plan
        (this as any).queryParams = {
          batchId: parsedBatchId,
          lessonPlanId: parsedLessonPlanId,
          topicId: parsedTopicId,
          instructorId: instructorIdParam ? parseInt(instructorIdParam) : null,
          activitySlotTemplateId: activitySlotTemplateIdParam ? parseInt(activitySlotTemplateIdParam) : null
        };
        // Early exit: handle direct URL navigation (from My Teaching Plan, etc.)
        // Bypass all activitySlotDetails / isUsingCacheMethod branching
        this.handleDirectLessonPlanLoad();
        // Close status dropdown when clicking outside
        document.addEventListener('click', this.handleClickOutside);
        return;
      } else if (parsedTopicId) {
        // If we have topicId but no lessonPlanId, set up as activity slot
        activitySlotDetails = {
          ...activitySlotDetails,
          batchId: parsedBatchId,
          topicId: parsedTopicId
        };
      } else {
        // If we only have batchId (no topicId or lessonPlanId), use selectedBatch flow
        activitySlotDetails = null;
      }
    }
    if (activitySlotDetails?.batchId && activitySlotDetails?.topicId) {
      this.setState({ selectedActivitySlot: activitySlotDetails });
      // Fetch batches first, then initialize lesson plans
      if (!this.useCacheMethod()) {
        this.fetchBatchData().then(() => {
          this.initLessonplans();
        });
      } else {
        this.batchservice.getBatches().then(
          (batches) => {
            const matchedBatch = batches.find(
              (batch: Batch) => batch.id === activitySlotDetails.batchId
            );
            this.setState({
              batches: batches,
              selectedBatch: matchedBatch || null
            }, () => {
              this.initLessonplans();
            });
          },
          (error) => {
            console.log(error);
            this.initLessonplans();
          }
        );
      }
    } else if (
      true ||
      (this.ATTENDANCE_CONFIG.allowLessonplanWithoutAttendance &&
        this.ATTENDANCE_CONFIG.allowLessonplanWithoutAttendance == true)
    ) {
      console.log("here");
      if (!this.useCacheMethod()) {
        this.fetchBatchData();
        return;
      }
      this.setState({ lessonplanWithOutAttendance: true });
      this.batchservice.getBatches().then(
        (batches) => {
          console.log(batches);
          const qp = (this as any).queryParams;
          if (qp?.batchId) {
            const matchedBatch = batches.find(
              (batch: Batch) => batch.id === qp.batchId
            );
            this.setState({ batches: batches, selectedBatch: matchedBatch || null }, () => {
              if (qp.lessonPlanId) {
                this.loadLessonPlanDirectly(qp.lessonPlanId, qp.batchId, qp.topicId);
              } else {
                this.displayBatchPicker();
              }
            });
          } else {
            this.setState({ batches: batches }, () => {
              this.displayBatchPicker();
            });
          }
        },
        (error) => {
          console.log(error);
        }
      );
    } else {
      console.log("in else");
      console.log(this.todayDate);
      AttendanceService.getScheduleActivitySlotsByDate(this.todayDate).then(
        (activitySlots) => {
          console.log(activitySlots);
          if (activitySlots.length > 0) {
            console.log("Inside if");
            this.setState({ activitySlots: activitySlots });
            console.log(activitySlots);
            this.displayLessonPlanSlotPicker();
          }
        },
        (error) => {
          console.log(error);
        }
      );
    }

    // Close status dropdown when clicking outside
    document.addEventListener('click', this.handleClickOutside);
  }

  componentWillUnmount(): void {
    document.removeEventListener('click', this.handleClickOutside);
  }

  handleClickOutside = () => {
    if (this.state.statusDropdownStepId !== null) {
      this.setState({ statusDropdownStepId: null });
    }
  };

  fetchBatchData = async () => {
    const instructorId = this.getEffectiveInstructorId();
    try {
      const responseDetails = await ApiService.syncBatches(instructorId);
      const fetchedBatches = responseDetails.data?.data;

      // Check for batchId from query params or location state
      const searchParams = new URLSearchParams(this.props.location.search);
      const batchIdParam = searchParams.get('batchId');
      const activitySlotDetails: any = this.props.location.state;

      const batchIdToFind = batchIdParam ? parseInt(batchIdParam) : activitySlotDetails?.batchId;

      if (batchIdToFind && fetchedBatches) {
        const matchedBatch = fetchedBatches.find(
          (batch: Batch) => batch.id === batchIdToFind
        );
        if (matchedBatch) {
          this.setState({
            batches: fetchedBatches,
            selectedBatch: matchedBatch
          }, () => {
            // If we have queryParams with lessonPlanId, load it directly
            const qp = (this as any).queryParams;
            if (qp?.lessonPlanId) {
              this.loadLessonPlanDirectly(qp.lessonPlanId, qp.batchId, qp.topicId);
            }
          });
        } else {
          this.setState({ batches: fetchedBatches });
        }
      } else {
        this.setState({ batches: fetchedBatches });
        this.displayBatchPicker();
      }

      return Promise.resolve();
    } catch (err) {
      console.log(err);
      return Promise.reject(err);
    }
  };

  loadLessonPlanDirectly = async (lessonPlanId: number, batchId: number, topicId: number | null) => {
    console.log(`Loading lesson plan directly: ${lessonPlanId} for batch ${batchId}`);

    // Fetch all lesson plans for the batch
    try {
      // Try IndexedDB first
      let lessonPlans = await this.lessonplanservice.getLessonPlansForBatch(batchId);

      // If cache is null/expired or no lesson plans found, fetch from API
      if (!lessonPlans || lessonPlans.length === 0) {
        console.log(`Lesson plans not in IndexedDB or cache expired, fetching from API...`);
        const instructorId = this.getEffectiveInstructorId();
        if (instructorId) {
          const response = this.useNodeBackend()
            ? await ApiService.syncLessonPlansNode(instructorId)
            : await ApiService.syncLessonPlans(instructorId);
          const allLessonPlans: LessonPlan[] = response.data?.data || [];
          // Save to IndexedDB for future use
          if (allLessonPlans.length > 0) {
            await this.lessonplanservice.addLessonPlans(allLessonPlans);
          }
          // Filter lesson plans for this batch
          lessonPlans = allLessonPlans.filter((lp: LessonPlan) =>
            lp.batches && lp.batches.includes(batchId)
          );
        } else {
          lessonPlans = [];
        }
      }

      // Find the target lesson plan
      let targetLessonPlan = lessonPlans.find((lp: LessonPlan) => lp.id === lessonPlanId);

      if (!targetLessonPlan) {
        console.error(`Lesson plan ${lessonPlanId} not found`);
        this.displayBatchPicker();
        return;
      }

      // Extract topicId from the lesson plan if not provided
      const finalTopicId = topicId || (targetLessonPlan.topics && targetLessonPlan.topics.length > 0 ? targetLessonPlan.topics[0] : null);

      if (!finalTopicId) {
        console.error("Could not determine topicId");
        return;
      }

      // Use batch topics for proper names if available
      const batchTopics = this.state.selectedBatch?.topics || [];

      // Collect all unique topics from all lesson plans for this batch
      const allTopicIds = new Set<number>();
      lessonPlans.forEach((lp: LessonPlan) => {
        if (lp.topics) {
          lp.topics.forEach((t: number) => allTopicIds.add(t));
        }
      });

      // Map topic IDs to topic objects with names from batch topics
      let topicsToSet = Array.from(allTopicIds).map(topicId => {
        const batchTopic = batchTopics.find((t: any) => t.id === topicId);
        return batchTopic || { id: topicId, name: `Topic ${topicId}` };
      });

      // If no topics found, use the finalTopicId
      if (topicsToSet.length === 0) {
        topicsToSet = [{ id: finalTopicId, name: "Topic" }];
      }

      // Filter all lesson plans for the selected topic (not just the target one)
      const matchedLessonPlans = lessonPlans.filter((lp: LessonPlan) =>
        lp.topics && lp.topics.some((t: number) => t === finalTopicId)
      );

      // Set up state with all required information
      const qp = (this as any).queryParams;
      this.setState({
        topics: topicsToSet,
        lesonplans: matchedLessonPlans.length > 0 ? matchedLessonPlans : [targetLessonPlan],
        lessonplanDetails: {
          lessonplanDate: this.todayDate,
          lessonplanId: lessonPlanId,
          batchId: batchId,
          topicId: finalTopicId,
          activitySlotId: qp?.activitySlotTemplateId || null,
          instructorId: qp?.instructorId || this.currentUser.instructorId,
        }
      }, () => {
        // Load the lesson plan steps
        this.getLessonplanSteps(targetLessonPlan);
      });
    } catch (error) {
      console.error("Error loading lesson plan:", error);
    }
  };

  /**
   * Handle direct URL navigation (e.g., from My Teaching Plan).
   * Fetches batches and lesson plans from API, bypassing IndexedDB cache
   * and the complex activitySlotDetails / isUsingCacheMethod branching.
   */
  handleDirectLessonPlanLoad = async () => {
    const qp = (this as any).queryParams;
    if (!qp?.batchId || !qp?.lessonPlanId) return;

    const instructorId = this.getEffectiveInstructorId();

    try {
      // 1. Fetch batches and find the matching one
      const batchResponse = await ApiService.syncBatches(instructorId);
      const fetchedBatches = batchResponse.data?.data || [];
      const matchedBatch = fetchedBatches.find((b: Batch) => b.id == qp.batchId) || null;

      // 2. Fetch lesson plans from API (bypass IndexedDB)
      const lpResponse = this.useNodeBackend()
        ? await ApiService.syncLessonPlansNode(instructorId)
        : await ApiService.syncLessonPlans(instructorId);
      const allLessonPlans: LessonPlan[] = lpResponse.data?.data || [];

      // Find the target lesson plan (loose equality for string/number safety)
      const targetLessonPlan = allLessonPlans.find((lp: LessonPlan) => lp.id == qp.lessonPlanId);

      if (!targetLessonPlan) {
        console.error(`Lesson plan ${qp.lessonPlanId} not found in API response`);
        this.showAlertDialog("Lesson plan not found. Please try again.");
        return;
      }

      // 3. Determine topicId
      const finalTopicId = qp.topicId || (targetLessonPlan.topics?.length > 0 ? targetLessonPlan.topics[0] : null);

      // 4. Build topics list from the matched batch's topics or from lesson plans
      const batchTopics = matchedBatch?.topics || [];
      let topicsToSet = batchTopics.length > 0
        ? batchTopics
        : (finalTopicId ? [{ id: finalTopicId, name: "Topic" }] : []);

      // 5. Filter lesson plans for the selected topic
      const matchedLessonPlans = allLessonPlans.filter((lp: LessonPlan) =>
        lp.topics && lp.topics.some((t: number) => t == finalTopicId)
      );

      // 6. Set up all state in one call to avoid race conditions with selectedBatch being overwritten
      this.setState({
        batches: fetchedBatches,
        selectedBatch: matchedBatch,
        lessonplanWithOutAttendance: true,
        topics: topicsToSet,
        lesonplans: matchedLessonPlans.length > 0 ? matchedLessonPlans : [targetLessonPlan],
        lessonplanDetails: {
          lessonplanDate: this.todayDate,
          lessonplanId: qp.lessonPlanId,
          batchId: qp.batchId,
          topicId: finalTopicId,
          activitySlotId: qp.activitySlotTemplateId || null,
          instructorId: qp.instructorId || this.currentUser.instructorId,
        }
      }, () => {
        this.getLessonplanSteps(targetLessonPlan);
      });
    } catch (error) {
      console.error("Error in handleDirectLessonPlanLoad:", error);
      this.showAlertDialog("Failed to load lesson plan. Please try again.");
    }
  };

  getBatch = (result: { batch: Batch }) => {
    console.log(result.batch, "here");
    this.setState({ selectedBatch: result.batch }, () => {
      console.log("Closed with:" + JSON.stringify(this.state.selectedBatch));
      console.log("Closed with:<<>>" + this.state.selectedBatch.name);
      this.initLessonplans();
    });
  };

  displayBatchPicker() {
    // const modalRef = this.modalService.open(ModalBatchPicker);
    // modalRef.componentInstance.my_modal_title = 'Batch Picker';
    // //modalRef.componentInstance.my_modal_content = 'Instructor batches..';
    // modalRef.componentInstance.batches = this.batches;
    // modalRef.result.then((result) => {
    //   this.selectedBatch = result.batch;
    //   console.log('Closed with:'+ JSON.stringify(this.selectedBatch ));
    //   console.log('Closed with:<<>>'+ this.selectedBatch.name);
    //   this.initLessonplans();
    // }, (reason) => {
    //   this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    //   console.log(this.closeResult);
    // });
    this.setState({ batchSlotPicker: true });
  }
  closeBatchPicker = () => {
    this.setState({ batchSlotPicker: false });
  };
  // getActivitySlot =(result: /*{ activitySlot: any; }*/)=>{
  getActivitySlot = (result: any) => {
    console.log(result);
    this.setState({ selectedActivitySlot: result }, () => {
      console.log("Closed with:" + this.state.selectedActivitySlot);
      console.log(
        "Closed with:<<>>" + this.state.selectedActivitySlot.batchName
      );
      this.initLessonplans();
    });
  };

  displayLessonPlanSlotPicker() {
    // console.log("In displayLessonPlanSlotPicker()...");
    // return()

    // const modalLessonplanSlotRef = this.modalService.open(ModalLessonplanSlotPicker);
    // modalLessonplanSlotRef.componentInstance.my_modal_title = 'Select class';
    // //modalRef.componentInstance.my_modal_content = 'Instructor batches..';
    // modalLessonplanSlotRef.componentInstance.activitySlots = this.activitySlots;
    // modalLessonplanSlotRef.result.then((result) => {
    //   this.selectedActivitySlot = result.activitySlot;
    //   console.log('Closed with:'+ JSON.stringify(this.selectedActivitySlot));
    //   console.log('Closed with:<<>>'+ this.selectedActivitySlot.batchName);
    //   this.initLessonplans();
    // }, (reason) => {
    //   this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    //   console.log(this.closeResult);
    // });
    this.setState({ lessonPlanSlotPickerFlag: true });
  }

  initLessonplans() {
    console.log("In initLessonplans()...");
    var today = new Date();
    var dd: any = today.getDate();
    var mm: any = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    //this.todayDate = dd+'/'+mm+'/'+yyyy;
    this.setState({
      lessonplanDetails: {
        lessonplanDate: dd + "/" + mm + "/" + yyyy,
        lessonplanId: -1,
        batchId: -1,
        topicId: -1,
        activitySlotId: -1,
        instructorId: this.currentUser.instructorId,
      },
    });
    console.log(this.state.selectedActivitySlot);
    if (this.state.selectedActivitySlot) {
      this.setState((prevState) => ({
        lessonplanDetails: {
          ...prevState.lessonplanDetails,
          batchId: this.state.selectedActivitySlot.batchId,
        },
      }));
      this.setState((prevState) => ({
        lessonplanDetails: {
          ...prevState.lessonplanDetails,
          activitySlotId: this.state.selectedActivitySlot.activitySlotId,
        },
      }));
      this.setState({
        topics: [
          {
            id: this.state.selectedActivitySlot.topicId,
            name: this.state.selectedActivitySlot.topicName,
          },
        ],
      });
      this.setState({ lessonplanSteps: [] });
      this.setState((prevState) => ({
        lessonplanDetails: {
          ...prevState.lessonplanDetails,
          topicId: this.state.selectedActivitySlot.topicId,
        },
      }));

      this.setState({ lessonPlanSlotPickerFlag: false });
      // Node mode goes straight to the API; Java mode keeps its original
      // IndexedDB-first path unchanged.
      this.useNodeBackend() ? this.fetchLessonPlan() : this.getLessonplans();
      //console.log("this.getLessonplans()...1");
    } else if (this.state.selectedBatch) {
      console.log("here");
      this.setState((prevState) => ({
        lessonplanDetails: {
          ...prevState.lessonplanDetails,
          batchId: this.state.selectedBatch.id,
          activitySlotId: null,
          topicId: -1,
        },
      }));
      this.setState({ topics: [] });
      this.getInstructorBatchTopics();
    }
  }

  getInstructorBatchTopics() {
    this.instructorBatchTopics = this.state.selectedBatch.topics;
    if (this.instructorBatchTopics.length > 0) {
      //displaying all topics mapped to batch & instructor.
      this.setState(
        (prevState) => ({
          lessonplanDetails: {
            ...prevState.lessonplanDetails,
            topicId: this.instructorBatchTopics[0].id,
          },
          topics: this.instructorBatchTopics,
          //pre-selecting first topic
        }),
        () => {
          this.useCacheMethod() ? this.getLessonplans() : this.fetchLessonPlan();
        }
      );
    }
  }

  onTopicChange(topicId: number) {
    console.log("IN onTopicChange()...", topicId);
    if (topicId > 0) {
      this.setState(
        (prevState) => ({
          lessonplanDetails: {
            ...prevState.lessonplanDetails,
            topicId: topicId,
          },
        }),
        () => {
          this.useCacheMethod() ? this.getLessonplans() : this.fetchLessonPlan();
        }
      );
    }
  }

  fetchLessonPlan = async () => {
    console.log(
      "In getLessonplans(), Lessonplan Details : " +
        JSON.stringify(this.state.lessonplanDetails)
    );

    const instructorId = this.getEffectiveInstructorId();

    try {
      console.log("hereee");
      const response = this.useNodeBackend()
        ? await ApiService.syncLessonPlansNode(instructorId)
        : await ApiService.syncLessonPlans(instructorId);
      console.log(response, "hereee");

      const lessonPlans: LessonPlan[] = response.data.data;
      const batchId = this.state.lessonplanDetails.batchId;
      const reqLessonPlan: LessonPlan[] = lessonPlans?.filter(
        (lessonPlan): boolean => lessonPlan.batches.includes(batchId)
      );

      // Filter the topics dropdown to only those that have lesson plans for this batch
      const lpTopicIdSet = new Set<number>(reqLessonPlan.flatMap((lp) => lp.topics || []));
      const filteredTopics = (this.state.selectedBatch?.topics || []).filter(
        (t: any) => lpTopicIdSet.has(t.id)
      );
      const topicsToUse = filteredTopics.length > 0 ? filteredTopics : this.state.topics;
      const topicStillValid = topicsToUse?.some(
        (t: any) => t.id === this.state.lessonplanDetails.topicId
      );
      const effectiveTopicId = topicStillValid
        ? this.state.lessonplanDetails.topicId
        : topicsToUse?.[0]?.id;

      if (filteredTopics.length > 0 && filteredTopics.length !== this.state.topics?.length) {
        this.setState((prevState) => ({
          topics: filteredTopics,
          lessonplanDetails: { ...prevState.lessonplanDetails, topicId: effectiveTopicId },
        }));
      }

      let matchedLessonPlans: LessonPlan[] = [];
      reqLessonPlan.forEach((_lessonPlan) => {
        if (_lessonPlan.topics.some((e) => e == effectiveTopicId)) {
          matchedLessonPlans.push(_lessonPlan);
        }
      });
      console.log("matchedLessonPlans: " + JSON.stringify(matchedLessonPlans));
      this.setState({ lesonplans: matchedLessonPlans }, () => {
        console.log(this.state.lesonplans);
        if (this.state.lesonplans.length > 0) {
          if (
            this.state.lessonplanDetails.lessonplanId !=
            this.state.lesonplans[0].id
          ) {
            console.log("inside if");
            this.setState((prevState) => ({
              lessonplanDetails: {
                ...prevState.lessonplanDetails,
                lessonplanId: this.state.lesonplans[0].id,
              },
            }),()=>{
              this.getLessonplanSteps(this.state.lesonplans[0]);
            });
          }
        } else {
          this.setState((prevState) => ({
            lessonplanDetails: {
              ...prevState.lessonplanDetails,
              lessonplanId: -1,
            },
            lessonplanSteps: [],
            lockedStepIds: new Set<number>(),
            isFlipClassEnabled: false,
          }));
          this.showAlertDialog(
            "No Lessonplan found for selected " +
              this.ATTENDANCE_CONFIG.topicDisplayName +
              " / " +
              this.ATTENDANCE_CONFIG.batchDisplayName +
              "."
          );
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  getLessonplans() {
    console.log(
      "In getLessonplans(), Lessonplan Details : " +
        JSON.stringify(this.state.lessonplanDetails)
    );
    this.setState({ lessonplanSteps: [] });

    this.dbservice.connect().then((d) => {
      this.lessonplanservice
        .getLessonPlansForBatch(this.state.lessonplanDetails.batchId)
        .then(
          (lessonPlans) => {
            // If cache expired (null returned), fetch fresh data from API
            if (!lessonPlans) {
              console.log("Cache expired or empty, fetching fresh data...");
              this.fetchLessonPlan();
              return;
            }

            console.log("lesonplans: " + JSON.stringify(lessonPlans));
            let matchedLessonPlans: LessonPlan[] = [];
            lessonPlans.forEach((_lessonPlan) => {
              if (
                _lessonPlan.topics.some(
                  (e) => e == this.state.lessonplanDetails.topicId
                )
              ) {
                matchedLessonPlans.push(_lessonPlan);
              }
            });
            console.log(
              "matchedLessonPlans: " + JSON.stringify(matchedLessonPlans)
            );
            this.setState({ lesonplans: matchedLessonPlans });
            setTimeout(() => {
              console.log(this.state.lesonplans);
              if (this.state.lesonplans.length > 0) {
                if (
                  this.state.lessonplanDetails.lessonplanId !=
                  this.state.lesonplans[0].id
                ) {
                  console.log("inside if");
                  this.setState((prevState) => ({
                    lessonplanDetails: {
                      ...prevState.lessonplanDetails,
                      lessonplanId: this.state.lesonplans[0].id,
                    },
                  }));
                  this.getLessonplanSteps(this.state.lesonplans[0]);
                }
              } else {
                this.setState((prevState) => ({
                  lessonplanDetails: {
                    ...prevState.lessonplanDetails,
                    lessonplanId: -1,
                  },
                  lessonplanSteps: [],
                  lockedStepIds: new Set<number>(),
                }));
                this.showAlertDialog(
                  "No Lessonplan found for selected " +
                    this.ATTENDANCE_CONFIG.topicDisplayName +
                    " / " +
                    this.ATTENDANCE_CONFIG.batchDisplayName +
                    "."
                );
              }
            }, 0);
          },
          (error) => {
            console.log(error);
          }
        );
    });
  }

  /**
   * Manually refresh lesson plans by clearing cache and fetching fresh data
   */
  handleRefreshLessonPlans = async () => {
    console.log("Refreshing lesson plans...");
    this.setState({ loading: true });

    try {
      // Clear the lesson plan cache
      await this.lessonplanservice.clearAllLessonPlans();

      // Fetch fresh data from API
      await this.fetchLessonPlan();

      console.log("Lesson plans refreshed successfully");
    } catch (error) {
      console.error("Error refreshing lesson plans:", error);
      this.showAlertDialog("Failed to refresh lesson plans. Please try again.");
    } finally {
      this.setState({ loading: false });
    }
  };

  onLessonplanChange(lessonplan: LessonPlan) {
    console.log(
      "In onLessonplanChange(), Lessonplan Details : " +
        JSON.stringify(this.state.lessonplanDetails)
    );
    this.getLessonplanSteps(lessonplan);
  }

  getLessonplanSteps(lessonplan: LessonPlan) {
    lessonplan.lessonPlanSteps.sort((a, b) => {
      const aOrder = a.sortOrder || 0;
      const bOrder = b.sortOrder || 0;
      if (aOrder !== bOrder) {
        return aOrder - bOrder;
      }
      // Fallback to startDate when sortOrder is equal or missing
      const aDate = a.startDate ? new Date(a.startDate).getTime() : 0;
      const bDate = b.startDate ? new Date(b.startDate).getTime() : 0;
      return aDate - bDate;
    });

    console.log(lessonplan, "here");

    console.log(
      "In getLessonplanSteps(), Lessonplan Id : " +
        this.state.lessonplanDetails.lessonplanId
    );
    // Fetch step statuses directly from server (no IndexedDB caching)
    (this.useNodeBackend()
      ? ApiService.syncLessonPlanStepStatusNode(this.currentUser.instructorId)
      : ApiService.syncLessonPlanStepStatus(this.currentUser.instructorId)
    ).then(
      (resp) => {
        const allStatuses = resp.data?.status === 1 ? (resp.data.data || []) : [];
        // Filter to only statuses for this lesson plan AND this batch
        const currentBatchId = this.state.lessonplanDetails.batchId;
        const lessonPlanStepStatuses = allStatuses.filter(
          (s: any) => s.lessonPlanId === lessonplan.id
            && (!currentBatchId || s.batchId === currentBatchId)
        );
        console.log("lessonPlanStepStatuses (from API):", JSON.stringify(lessonPlanStepStatuses));

        this.buildStepsFromStatuses(lessonplan, lessonPlanStepStatuses);
      },
      (error) => {
        console.error("Failed to fetch step statuses from API, proceeding with defaults:", error);
        this.buildStepsFromStatuses(lessonplan, []);
      }
    );
  }

  getLessonplanSteps1(lessonplanId: string) {
    console.log(
      "In getLessonplanSteps(), Lessonplan Id : " +
        this.state.lessonplanDetails.lessonplanId
    );
    let lessonplan = this.state.lesonplans.find(
      (l) => l.id === Number(lessonplanId)
    );

    lessonplan.lessonPlanSteps.sort((a, b) => {
      const aOrder = a.sortOrder || 0;
      const bOrder = b.sortOrder || 0;
      if (aOrder !== bOrder) {
        return aOrder - bOrder;
      }
      const aDate = a.startDate ? new Date(a.startDate).getTime() : 0;
      const bDate = b.startDate ? new Date(b.startDate).getTime() : 0;
      return aDate - bDate;
    });

    // Fetch step statuses directly from server (no IndexedDB caching)
    (this.useNodeBackend()
      ? ApiService.syncLessonPlanStepStatusNode(this.currentUser.instructorId)
      : ApiService.syncLessonPlanStepStatus(this.currentUser.instructorId)
    ).then(
      (resp) => {
        const allStatuses = resp.data?.status === 1 ? (resp.data.data || []) : [];
        // Filter to only statuses for this lesson plan AND this batch
        const currentBatchId = this.state.lessonplanDetails.batchId;
        const lessonPlanStepStatuses = allStatuses.filter(
          (s: any) => s.lessonPlanId === lessonplan.id
            && (!currentBatchId || s.batchId === currentBatchId)
        );
        console.log("lessonPlanStepStatuses (from API):", JSON.stringify(lessonPlanStepStatuses));

        this.buildStepsFromStatuses(lessonplan, lessonPlanStepStatuses);
      },
      (error) => {
        console.error("Failed to fetch step statuses from API, proceeding with defaults:", error);
        this.buildStepsFromStatuses(lessonplan, []);
      }
    );
  }

  /**
   * Build lesson plan steps with their status details from API data.
   * Shared by getLessonplanSteps and getLessonplanSteps1.
   */
  buildStepsFromStatuses(lessonplan: LessonPlan, lessonPlanStepStatuses: any[]) {
    let lessonplanStepStatusMap = new Map();
    if (lessonPlanStepStatuses.length > 0) {
      lessonPlanStepStatuses.forEach((_lessonPlanStepStatus) => {
        lessonplanStepStatusMap.set(
          _lessonPlanStepStatus.stepId,
          _lessonPlanStepStatus
        );
      });
    }
    let lessonplanSteps = [];
    lessonplan.lessonPlanSteps.forEach((_lessonPlanStep) => {
      let _statusDetails = {
        id: 0,
        lessonPlanId: lessonplan.id,
        stepId: _lessonPlanStep.id,
        batchId: this.state.lessonplanDetails.batchId,
        completedById: this.currentUser.instructorId,
        statusTypeId: 1,
        startedDate: null,
        completedDate: null,
        activitySlotId: this.state.lessonplanDetails.activitySlotId || null,
      };
      let statusDetails = lessonplanStepStatusMap.get(_lessonPlanStep.id)
        ? lessonplanStepStatusMap.get(_lessonPlanStep.id)
        : _statusDetails;
      let lessonPlanStep: any = _lessonPlanStep;
      lessonPlanStep.statusDetails = statusDetails;
      lessonplanSteps.push(lessonPlanStep);
    });

    const lockedIds = this.computeLockedStepsFromEndDate(lessonplanSteps);
    this.setState({ lessonplanSteps: lessonplanSteps, lockedStepIds: lockedIds });
    this.fetchLockStates(lessonplanSteps);
  }

  saveLessonplanStatus(lessonplanStep: any) {
    console.log(
      "In saveLessonplanStatus()..., step : " + JSON.stringify(lessonplanStep)
    );
    // Check if step is locked
    if (this.state.lockedStepIds.has(lessonplanStep.id)) {
      this.setState({
        showAlert: true,
        alertMessage: "This step is locked because its planned end date has passed. Use 'Request Access' to request temporary editing permission.",
        alertTitle: "Step Locked",
      });
      return;
    }

    // Get current status and find next status based on sortOrder
    const currentStatusId = lessonplanStep.statusDetails.statusTypeId;
    const sortedStatuses = [...this.state.statusTypes].sort((a, b) => a.sortOrder - b.sortOrder);
    const currentIndex = sortedStatuses.findIndex(s => s.id === currentStatusId);

    if (currentIndex === -1) {
      // Current status not found, default to first status
      if (sortedStatuses.length > 0) {
        this.editLessonplanStatus(lessonplanStep, sortedStatuses[0].id);
      }
      return;
    }

    // Move to next status in sequence
    const nextIndex = currentIndex + 1;
    if (nextIndex < sortedStatuses.length) {
      this.editLessonplanStatus(lessonplanStep, sortedStatuses[nextIndex].id);
    } else {
      // Already at last status
      alert(`Step already at final status: ${sortedStatuses[currentIndex].name}`);
    }
  }

  editLessonplanStatus(lessonplanStep: any, statusId) {
    console.log(
      "In editLessonplanStatus(), step : " +
        JSON.stringify(lessonplanStep) +
        "; StatusId : " +
        statusId
    );
    // Check if step is locked
    if (this.state.lockedStepIds.has(lessonplanStep.id)) {
      this.setState({
        showAlert: true,
        alertMessage: "This step is locked because its planned end date has passed.",
        alertTitle: "Step Locked",
      });
      return;
    }

    if (lessonplanStep.statusDetails.statusTypeId == statusId) {
      return;
    }

    // Build the status payload with date fields
    const lessonplanDate = this.state.lessonplanDetails.lessonplanDate;
    const statusPayload = { ...lessonplanStep.statusDetails, statusTypeId: statusId, syncStatus: 1 };

    if (statusId == 1) {
      statusPayload.warmupDate = null;
      statusPayload.startedDate = null;
      statusPayload.completedDate = null;
      statusPayload.createdDate = lessonplanDate;
    } else if (statusId == 4) {
      statusPayload.warmupDate = lessonplanDate;
      statusPayload.createdDate = lessonplanDate;
      statusPayload.startedDate = null;
      statusPayload.completedDate = null;
    } else if (statusId == 2) {
      statusPayload.startedDate = lessonplanDate;
      statusPayload.completedDate = null;
    } else {
      statusPayload.completedDate = lessonplanDate;
    }

    // Get current user
    const currentUser = JSON.parse(localStorage.getItem('user') || '{}');

    // Call API first — only update UI on success
    const lessonplanData = {
      submittedBy: currentUser.instructorId,
      lessonplanStatus: [statusPayload],
    };

    ApiService.syncOutLessonplanStatus(lessonplanData).then(
      (res) => {
        const respData = res.data;
        console.log("Status save response:", respData);

        if (respData.status === 0) {
          this.setState({
            showAlert: true,
            alertMessage: respData.message || "Failed to update step status.",
            alertTitle: "Error",
          });
          return;
        }

        // Check for locked steps BEFORE updating UI state
        const lockedStepIdSet = new Set<number>();
        if (respData.data?.lockedSteps && respData.data.lockedSteps.length > 0) {
          respData.data.lockedSteps.forEach((locked: any) => {
            lockedStepIdSet.add(locked.stepId);
          });
        }

        // Only update UI state if step was NOT rejected as locked
        const lessonplansteps = this.state.lessonplanSteps;
        const step = lessonplansteps.find((l) => l.id === lessonplanStep.id);
        if (step && !lockedStepIdSet.has(lessonplanStep.id)) {
          step.statusDetails = { ...step.statusDetails, ...statusPayload };
        }
        this.setState({ lessonplanSteps: lessonplansteps });

        // Show resource activation results if any
        if (respData.data?.assignmentResults && respData.data.assignmentResults.length > 0) {
          const results = respData.data.assignmentResults[0];
          if (results.resourceDetails && results.resourceDetails.length > 0) {
            const statusType = this.state.statusTypes.find(s => s.id === statusId);
            this.setState({
              showResourceActivationModal: true,
              activationResults: {
                stepName: step?.name || "Step",
                statusName: statusType?.name || "Unknown Status",
                totalAssignments: results.resourceDetails.length,
                resourceDetails: results.resourceDetails
              }
            });
          }
        }

        // Handle locked steps — add to lockedStepIds and alert
        if (lockedStepIdSet.size > 0) {
          const newLocked = new Set(this.state.lockedStepIds);
          lockedStepIdSet.forEach((id) => newLocked.add(id));
          this.setState({
            lockedStepIds: newLocked,
            showAlert: true,
            alertMessage: `${lockedStepIdSet.size} step(s) could not be updated because their planned end date has passed.`,
            alertTitle: "Steps Locked",
          });
        }
      },
      (error) => {
        const msg = error?.response?.data?.message || error?.message || "Failed to update step status. Please try again.";
        this.setState({
          showAlert: true,
          alertMessage: msg,
          alertTitle: "Error",
        });
      }
    );
  }

  /**
   * Fetch lock states from backend API and refine lockedStepIds.
   * The initial lock state is already set synchronously from endDate parsing.
   * This call refines it with PlannedEndDate and active unlock data from the backend.
   */
  fetchLockStates = (lessonplanSteps: any[]) => {
    const batchId = this.state.lessonplanDetails.batchId;
    const lessonPlanId = this.state.lessonplanDetails.lessonplanId;

    if (!batchId || !lessonPlanId) {
      return;
    }

    const currentUser = AuthenticationService.currentUserValue;
    ApiService.getLockStates(lessonPlanId, batchId, currentUser?.userId)
      .then((res) => {
        // Read flip class flag from response
        if (res.data?.flipClassEnabled !== undefined) {
          this.setState({ isFlipClassEnabled: !!res.data.flipClassEnabled });
        }

        const lockData = res.data?.data;
        if (!lockData || typeof lockData !== "object" || Object.keys(lockData).length === 0) {
          return; // Keep the synchronous locks from endDate
        }

        const lockedIds = new Set<number>();
        const requestStatuses = new Map<number, any>();
        lessonplanSteps.forEach((step: any) => {
          const stepLock = lockData[step.id];
          if (stepLock) {
            // Attach lock info to step for use in rendering
            step.lcsLock = stepLock;
            // Backend now uses both PlannedEndDate and EndDateTime - trust its isLocked
            if (stepLock.isLocked && !stepLock.hasActiveUnlock) {
              lockedIds.add(step.id);
            }
            // Extract latest access request status
            if (stepLock.latestRequest) {
              requestStatuses.set(step.id, stepLock.latestRequest);
            }
            // Override displayed dates with batch-specific planned dates
            const effectiveStart = stepLock.plannedStartDate || stepLock.startDateTime;
            const effectiveEnd = stepLock.plannedEndDate || stepLock.endDateTime;
            if (effectiveStart) {
              step.startDate = this.formatISOtoDDMMYY(effectiveStart);
            }
            if (effectiveEnd) {
              step.endDate = this.formatISOtoDDMMYY(effectiveEnd);
            }
          } else {
            // No backend data for this step - keep endDate-based lock
            if (this.state.lockedStepIds.has(step.id)) {
              lockedIds.add(step.id);
            }
          }
        });

        this.setState({ lockedStepIds: lockedIds, accessRequestStatuses: requestStatuses, lessonplanSteps: [...lessonplanSteps] });
      })
      .catch((err) => {
        console.error("Failed to fetch lock states from API:", err);
        // Keep the synchronous locks from endDate - no action needed
      });
  };

  /**
   * Compute locked steps from step.endDate (DD/MM/YY format).
   * Returns the Set of locked step IDs (synchronous, no setState).
   */
  computeLockedStepsFromEndDate = (lessonplanSteps: any[]): Set<number> => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const lockedIds = new Set<number>();

    lessonplanSteps.forEach((step: any) => {
      const dateStr = step.endDate;
      if (dateStr) {
        const parsed = this.parseDDMMYY(dateStr);
        if (parsed && parsed < today) {
          lockedIds.add(step.id);
        }
      }
    });

    return lockedIds;
  };

  /**
   * Parse a date string in DD/MM/YY or DD/MM/YYYY format.
   * Returns a Date or null if unparseable.
   */
  parseDDMMYY = (dateStr: string): Date | null => {
    if (!dateStr) return null;
    const parts = dateStr.split("/");
    if (parts.length !== 3) return null;
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1; // 0-indexed
    let year = parseInt(parts[2], 10);
    if (year < 100) year += 2000; // YY -> 20YY
    const d = new Date(year, month, day);
    if (isNaN(d.getTime())) return null;
    return d;
  };

  /**
   * Format an ISO date string to DD/MM/YY for display (inverse of parseDDMMYY).
   */
  formatISOtoDDMMYY = (isoStr: string): string => {
    const d = new Date(isoStr);
    if (isNaN(d.getTime())) return '';
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yy = String(d.getFullYear()).slice(-2);
    return `${dd}/${mm}/${yy}`;
  };

  getRelativeTime = (dateStr: string): string => {
    const now = Date.now();
    const then = new Date(dateStr).getTime();
    const diffMs = now - then;
    const diffMin = Math.floor(diffMs / 60000);
    if (diffMin < 1) return "just now";
    if (diffMin < 60) return `${diffMin}m ago`;
    const diffHours = Math.floor(diffMin / 60);
    if (diffHours < 24) return `${diffHours}h ago`;
    const diffDays = Math.floor(diffHours / 24);
    return `${diffDays}d ago`;
  };

  getTimeUntil = (dateStr: string): string => {
    const now = Date.now();
    const then = new Date(dateStr).getTime();
    const diffMs = then - now;
    if (diffMs <= 0) return "expired";
    const diffHours = Math.floor(diffMs / 3600000);
    if (diffHours < 1) return "< 1h";
    if (diffHours < 24) return `${diffHours}h`;
    const diffDays = Math.floor(diffHours / 24);
    return `${diffDays}d`;
  };

  submitAccessRequest = () => {
    const step = this.state.accessRequestStep;
    if (!step) return;

    const currentUser = AuthenticationService.currentUserValue;

    ApiService.submitLcsAccessRequest({
      lessonPlanStepId: step.id,
      lessonPlanId: step.lessonPlanId || this.state.lessonplanDetails.lessonplanId,
      batchId: this.state.lessonplanDetails.batchId,
      userId: currentUser?.userId,
      reason: this.state.accessRequestReason,
    }).then(
      (res) => {
        const data = res.data;
        if (data.status === 1) {
          // Optimistic update: show PENDING status immediately
          const newStatuses = new Map(this.state.accessRequestStatuses);
          newStatuses.set(step.id, {
            id: data.data?.id || 0,
            status: "PENDING",
            requestedAt: new Date().toISOString(),
            reviewedAt: null,
            reviewRemarks: null,
            unlockExpiresAt: null,
          });
          this.setState({
            showAccessRequestModal: false,
            accessRequestStatuses: newStatuses,
            accessRequestReason: "",
            showAlert: true,
            alertMessage: "Your access request has been submitted. An admin will review it shortly.",
            alertTitle: "Request Submitted",
          });
        } else {
          this.setState({
            showAccessRequestModal: false,
            showAlert: true,
            alertMessage: data.message || "Failed to submit request.",
            alertTitle: "Error",
          });
        }
      },
      (error) => {
        if (error?.response?.status === 409) {
          // A pending request already exists - update local state to reflect that
          const newStatuses = new Map(this.state.accessRequestStatuses);
          if (!newStatuses.has(step.id)) {
            newStatuses.set(step.id, {
              id: 0,
              status: "PENDING",
              requestedAt: new Date().toISOString(),
              reviewedAt: null,
              reviewRemarks: null,
              unlockExpiresAt: null,
            });
          }
          this.setState({
            showAccessRequestModal: false,
            accessRequestStatuses: newStatuses,
            showAlert: true,
            alertMessage: "A pending request already exists for this step.",
            alertTitle: "Info",
          });
        } else {
          const msg = error?.response?.data?.message || error?.message || "Failed to submit access request. Please try again.";
          this.setState({
            showAccessRequestModal: false,
            showAlert: true,
            alertMessage: msg,
            alertTitle: "Error",
          });
        }
      }
    );
  };

  displayStepDetails(step: any) {
    console.log("In displayStepDetails()... " + JSON.stringify(step));
    if (step.statusDetails.id > 0) {
      this.setState({
        editLessonPlanStep: step,
        editLessonPlanStepStatus: step.statusDetails.statusTypeId,
      });
      setTimeout(() => {
        this.setState({ showStatusEditModal: true });
        if (this.state.StatusEditModalClicked) {
          // console.log( `Closed with: ${result}`);
          console.log(this.state.editLessonPlanStep);
          let _statusId = this.state.editLessonPlanStep;
          // this.editLessonplanStatus(step, _statusId)
        }
      }, 0);
      // this.modalService.open(content, {ariaLabelledBy: 'modal-step-status-edit-title'}).result.then((result) => {
      //   console.log( `Closed with: ${result}`);
      //   let _statusId = this.state.editLessonPlanStepStatusId;
      //   this.editLessonplanStatus(step, _statusId);
      // }, (reason) => {
      //   console.log( `Dismissed with: ${reason}`);
      //   // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      // });
    }
  }

  openAnalyticsModal(step: any) {
    console.log("Opening analytics for step:", step);

    // Open analytics in a new window/tab
    const lessonPlanId = this.state.lessonplanDetails?.lessonplanId || 0;
    const batchId = this.state.lessonplanDetails?.batchId || 0;
    const stepId = step.id;

    const url = `/step-analytics?lessonPlanId=${lessonPlanId}&stepId=${stepId}&batchId=${batchId}&stepName=${encodeURIComponent(step.name)}`;
    window.open(url, '_blank');
  }

  closeAnalyticsModal = () => {
    this.setState({
      showAnalyticsModal: false,
      selectedAnalyticsStep: null,
    });
  }

  more(lessonplanStep: any) {
    console.log("In more(), step : " + JSON.stringify(lessonplanStep));
    this.setState({ loading: true });
    (this.useNodeBackend()
      ? ApiService.getLessonplanStepAttachmentsNode(lessonplanStep.id)
      : ApiService.getLessonplanStepAttachments(lessonplanStep.id)
    ).then(
      (res) => {
        const respData = res.data;
        this.setState({ loading: false });
        console.log("more(), Response : " + JSON.stringify(respData));
        this.displayMoreOptions(respData.data, lessonplanStep);
      },
      (error) => {
        this.setState({ loading: false });
        console.log("Unable to get data Network Error: " + error.message);
        this.connectionError();
      }
    );
  }

  displayMoreOptions(options: any, lessonplanStep: any) {
    //options = step testMappings
    console.log("In displayMoreOptions()...");
    this.setState({ moreOptions: options });
    this.setState({ showMoreOptions: true });

    if (this.state.MoreOptionsClicked) {
      this.issueTests(lessonplanStep);
    }
    // this.modalService.open(content, {ariaLabelledBy: 'modal-step-status-edit-title'}).result.then((result) => {
    //   console.log( `Closed with: ${result}`);

    // }, (reason) => {
    //   console.log( `Dismissed with: ${reason}`);
    //   // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    // });
  }

  issueTests(lessonplanStep: any) {
    console.log(
      "Step Id : " +
        lessonplanStep.id +
        ", Lessonplan Details : " +
        JSON.stringify(this.state.lessonplanDetails)
    );
    console.log("Batch Details : " + JSON.stringify(this.state.selectedBatch));
    this.setState({ loading: true });
    let data = {
      lessonplanId: this.state.lessonplanDetails.lessonplanId,
      lessonplanStepId: lessonplanStep.id,
      topicId: this.state.lessonplanDetails.topicId,
      batchId: this.state.lessonplanDetails.batchId,
      instructorId: this.currentUser.instructorId,
    };

    (this.useNodeBackend()
      ? ApiService.issueLessonplanStepTestsNode(data)
      : ApiService.issueLessonplanStepTests(data)
    ).then(
      (res) => {
        const respData = res.data;
        this.setState({ loading: false });
        console.log("issueTests(), Response : " + JSON.stringify(respData));
        if (respData.status == 0) {
          this.showAlertDialogMsg(respData.message, "Error");
        } else {
          this.showAlertDialogMsg(respData.message, "Success");
        }
      },
      (error) => {
        this.setState({ loading: false });
        console.log("Unable to get data Network Error: " + error.message);
        this.connectionError();
      }
    );
  }

  public showAlertDialog(message: string) {
    console.log("in alert");
    this.setState({ showAlert: true, alertMessage: message });
    // if(confirmed)  console.log('User confirmed:', confirmed)
    // else console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog )');
  }

  public showAlertDialogMsg(message: string, title: string) {
    console.log("in alert");
    this.setState({
      showAlert: true,
      alertMessage: message,
      alertTitle: title,
    });
    // DialogService.alert(message,title)
    // if(confirmed)  console.log('User confirmed:', confirmed)
    // else console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog )');
  }

  public connectionError() {
    console.log("in alert");
    //public CONNECTION_ERROR_MSG:string ="The server is taking too long to respond OR something is wrong with your internet connection. Please try again later."
    this.setState({
      showAlert: true,
      alertMessage: Config.CONNECTION_ERROR_MSG,
    });
    // if(confirmed)  console.log('User confirmed:', confirmed)
    // else console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog )');
  }

  // private getDismissReason(reason: any): string {
  //   if (reason === ModalDismissReasons.ESC) {
  //     return 'by pressing ESC';
  //   } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
  //     return 'by clicking on a backdrop';
  //   } else {
  //     return  `with: ${reason}`;
  //   }
  // }
  public handleAlert = (flag) => {
    this.setState({ showAlert: false });
    if (flag) {
      console.log("user clicked yes");
    } else console.log("user dismissed the alert");
  };
  public _dismiss() {
    this.props.history.push("/");
  }

  render() {
    console.log(this.state.activitySlots);
    return (
      <div className="lesson-plan">
        {this.state.showAlert && (
          <AlertDialog
            message={this.state.alertMessage}
            title={this.state.alertTitle}
            btnOkText="OK"
            size="lg"
            close={this.handleAlert}
          />
        )}
        <div className="app flex-row align-items-center">
          <div className="container">
            <div className="card-group">
              <div className="card text-center border-info full-height1">
                <div className="card-header pageheading bg-info text-white">
                  <FontAwesomeIcon
                    icon={faArrowLeft}
                    size="lg"
                    className="float-left"
                    onClick={() => this._dismiss()}
                  ></FontAwesomeIcon>
                  <b>Lessonplan</b>
                </div>
                <div className="card-body">
                  {this.state.batchSlotPicker && (
                    <ModalBatchPicker
                      my_modal_title="Batch Picker"
                      my_modal_content="Instructor batches.."
                      batches={this.state.batches}
                      getResult={this.getBatch}
                      close={this.closeBatchPicker}
                    />
                  )}
                  {this.state.lessonPlanSlotPickerFlag && (
                    <ModalLessonplanSlotPicker
                      my_modal_content="Instructor batches.."
                      my_modal_title="Select class"
                      activitySlots={this.state.activitySlots}
                      getActivitySlot={this.getActivitySlot}
                    />
                  )}
                  {this.state.selectedActivitySlot &&
                    this.state.lessonplanWithOutAttendance === false && (
                      <div
                        className="row"
                        onClick={() => this.displayLessonPlanSlotPicker()}
                      >
                        <div className="col text-left">
                          <h5>{this.state.selectedActivitySlot.batchName}</h5>
                          <div>{this.state.selectedActivitySlot.topicName}</div>
                          <div className="float-right">
                            {this.state.selectedActivitySlot.startTime}{" "}
                            &nbsp;-&nbsp;
                            {this.state.selectedActivitySlot.endTime}
                          </div>
                        </div>
                      </div>
                    )}
                  {/*! fix logic here*/}
                  {!this.state.selectedActivitySlot &&
                    this.state.lessonplanWithOutAttendance == false &&
                    false && (
                      <div
                        className="row"
                        onClick={() => this.displayLessonPlanSlotPicker()}
                      >
                        <div className="col text-left">
                          <h5>--Select Class--</h5>
                        </div>
                      </div>
                    )}
                                    {/*! fix logic here*/}

                  {(this.state.lessonplanWithOutAttendance == true || true) && (
                    <div
                      className="row"
                      onClick={() => this.displayBatchPicker()}
                    >
                      <div className="col text-left">
                        <h5>
                          {this.state.selectedBatch
                            ? this.state.selectedBatch.name
                            : "--Select " +
                              this.ATTENDANCE_CONFIG.batchDisplayName +
                              "--"}
                        </h5>
                        <div className="course-name-wrapper">
                          {this.state.selectedBatch?.courseName}
                        </div>
                        <div className="course-name-wrapper">
                          {this.state.selectedBatch?.schoolName}
                        </div>
                      </div>
                    </div>
                  )}
                  {!this.state.selectedActivitySlot && (
                    <div className="row">
                      <div className="col col-5 text-left">
                        <label htmlFor="topic" className="my-label">
                          {this.ATTENDANCE_CONFIG.topicDisplayName}
                        </label>
                      </div>
                      <div className="col text-right">
                        <select
                          className="form-control"
                          onChange={(e) => this.onTopicChange(Number(e.target.value))}
                          // [(ngModel)]="lessonplanDetails.topicId"
                        >
                          {this.state.topics?.map((topic, i) => (
                            <option
                              value={topic.id}
                              key={i}
                              selected={
                                topic.id ===
                                this.state.lessonplanDetails.topicId
                              }
                            >
                              {topic.name}
                            </option>
                          ))}

                          {(this.state.topics == null ||
                            this.state.topics.length <= 0) && (
                            <option
                              value="-1"
                              selected={
                                this.state.lessonplanDetails.topicId == -1
                              }
                            >
                              #None
                            </option>
                          )}
                        </select>
                      </div>
                    </div>
                  )}
                  <div className="row">
                    <div className="col col-5 text-left d-flex align-items-center">
                      <label htmlFor="topic" className="my-label mb-0">
                        Lesson Plan
                      </label>
                      <button
                        className="btn btn-sm btn-link p-0 ml-2"
                        onClick={this.handleRefreshLessonPlans}
                        title="Refresh lesson plan data"
                        disabled={this.state.loading}
                      >
                        <FontAwesomeIcon
                          icon={faSync}
                          spin={this.state.loading}
                          style={{ fontSize: '14px', color: '#006ddd' }}
                        />
                      </button>
                    </div>
                    <div className="col text-right">
                      {/* {console.log(this.state.lessonplanSteps)} */}
                      <select
                        className="form-control"
                        value={this.state.lessonplanDetails.lessonplanId}
                        onChange={(e) => {
                          this.setState((prevState) => ({
                            lessonplanDetails: {
                              ...prevState.lessonplanDetails,
                              lessonplanId: e.target.value,
                            },
                          }));
                          this.getLessonplanSteps1(e.target.value);
                        }}
                      >
                        {this.state.lesonplans?.map((lessonplan, i) => (
                          <option
                            key={i}
                            value={lessonplan.id}
                            // onClick={() =>}
                            // selected={this.state.lessonplanDetails.lessonplanId == lessonplan.id}
                          >
                            {lessonplan.name}
                          </option>
                        ))}

                        {(this.state.lesonplans == null ||
                          this.state.lesonplans.length <= 0) && (
                          <option
                            value={-1}
                            // selected={this.state.lessonplanDetails.lessonplanId == -1}
                          >
                            #None
                          </option>
                        )}
                      </select>
                    </div>
                  </div>
                  {this.state.lessonplanSteps.map((step, i) => (
                    <div className={`row ${this.state.lockedStepIds.has(step.id) ? 'step-locked' : ''}`} key={i}>
                      <div
                        className="col col-auto align-self-center align-items-center"
                        onClick={() => this.saveLessonplanStatus(step)}
                        style={this.state.lockedStepIds.has(step.id) ? { cursor: 'not-allowed' } : {}}
                      >
                        {/* <!--<img  src="./assets/img/not-started.png" width="32px" height="32px"/>--> */}
                        {step.statusDetails.statusTypeId == 1 && (
                          <img
                            src={notStartedImage}
                            width="32px"
                            height="32px"
                          />
                        )}
                        {step.statusDetails.statusTypeId == 4 && (
                          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="16" cy="16" r="16" fill="#FEF3C7"/>
                            <circle cx="16" cy="16" r="14.5" stroke="var(--status-warning)" strokeWidth="1" strokeOpacity="0.3"/>
                            <path d="M16 6C16 6 11 13 11 17.5C11 20.5 13.2 23 16 23C18.8 23 21 20.5 21 17.5C21 13 16 6 16 6Z" fill="url(#warmup-grad)" />
                            <path d="M16 14C16 14 13.5 17.5 13.5 19.5C13.5 21 14.6 22 16 22C17.4 22 18.5 21 18.5 19.5C18.5 17.5 16 14 16 14Z" fill="#FDE68A"/>
                            <defs>
                              <linearGradient id="warmup-grad" x1="16" y1="6" x2="16" y2="23" gradientUnits="userSpaceOnUse">
                                <stop stopColor="#F97316"/>
                                <stop offset="1" stopColor="var(--status-danger)"/>
                              </linearGradient>
                            </defs>
                          </svg>
                        )}
                        {step.statusDetails.statusTypeId == 2 && (
                          <img src={startedImage} width="32px" height="32px" />
                        )}
                        {step.statusDetails.statusTypeId == 3 && (
                          <img
                            src={completedImage}
                            width="32px"
                            height="32px"
                          />
                        )}
                      </div>
                      {/* Change Status button - only show when not locked */}
                      {!this.state.lockedStepIds.has(step.id) && (
                        <div
                          className="col col-auto align-self-center"
                          style={{ paddingLeft: 4, position: 'relative' }}
                        >
                          <button
                            className="btn-change-status"
                            onClick={(e) => {
                              e.stopPropagation();
                              this.setState({
                                statusDropdownStepId: this.state.statusDropdownStepId === step.id ? null : step.id
                              });
                            }}
                            title="Change Status"
                          >
                            ⋮
                          </button>
                          {this.state.statusDropdownStepId === step.id && (
                            <div className="status-dropdown" onClick={(e) => e.stopPropagation()}>
                              {this.state.statusTypes.map((statusType) => {
                                // Icon mapping for each status type
                                const getStatusIcon = (id: number) => {
                                  switch(id) {
                                    case 1: return '○'; // Not Started
                                    case 4: return '🔥'; // Warm Up
                                    case 2: return '▶'; // Started
                                    case 3: return '✓'; // Completed
                                    default: return '●';
                                  }
                                };

                                return (
                                  <div
                                    key={statusType.id}
                                    className={`status-option ${step.statusDetails.statusTypeId === statusType.id ? 'active' : ''}`}
                                    onClick={() => {
                                      this.editLessonplanStatus(step, statusType.id);
                                      this.setState({ statusDropdownStepId: null });
                                    }}
                                  >
                                    {getStatusIcon(statusType.id)} {statusType.name}
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      )}
                      {/* Analytics button hidden per user request */}
                      {/* <div
                        className="col col-auto align-self-center align-items-center"
                        style={{ paddingLeft: 8 }}
                      >
                        <button
                          className="btn-analytics-small"
                          onClick={(e) => {
                            e.stopPropagation();
                            this.openAnalyticsModal(step);
                          }}
                          title="View student activity analytics"
                        >
                          📊
                        </button>
                      </div> */}
                      {this.state.isFlipClassEnabled && (
                      <div
                        className="col col-auto align-self-center align-items-center"
                        style={{ paddingLeft: 4 }}
                      >
                        <button
                          className="btn-analytics-small"
                          onClick={(e) => {
                            e.stopPropagation();
                            const lessonPlanId = this.state.lessonplanDetails?.lessonplanId || 0;
                            const batchId = this.state.selectedBatch?.id;
                            if (!batchId) {
                              alert('Please select a batch first');
                              return;
                            }
                            window.open(`/lesson-plan/${lessonPlanId}/step/${step.id}/class-review?batchId=${batchId}`, '_blank');
                          }}
                          title="Open class review dashboard"
                        >
                          📋
                        </button>
                      </div>
                      )}
                      <div
                        className="col text-left align-self-center align-items-center"
                        onClick={() => this.displayStepDetails(step)}
                      >
                        <span>
                          {step.name}
                          {/* <!--<p>[ {{step.startDate}} - {{step.endDateTime} ] </p>--> */}
                          {step.statusDetails.statusTypeId == 1 && (
                            <p>
                              [ {step.startDate} - {step.endDate} ]{" "}
                            </p>
                          )}
                          {step.statusDetails.statusTypeId == 4 && (
                            <p>
                              [ {step.startDate} - {step.endDate} ] Warming up since{" "}
                              {step.statusDetails.warmupDate}
                            </p>
                          )}
                          {step.statusDetails.statusTypeId == 2 && (
                            <p>
                              [ {step.startDate} - {step.endDate} ] Started on{" "}
                              {step.statusDetails.startedDate}
                            </p>
                          )}
                          {step.statusDetails.statusTypeId == 3 && (
                            <p>
                              [ {step.startDate} - {step.endDate} ] Completed on{" "}
                              {step.statusDetails.completedDate}
                            </p>
                          )}
                          {this.state.lockedStepIds.has(step.id) && (
                            <span className="lock-badge">Locked</span>
                          )}
                          {!this.state.lockedStepIds.has(step.id) && (() => {
                            const reqStatus = this.state.accessRequestStatuses.get(step.id);
                            if (reqStatus?.status === "APPROVED" && reqStatus.unlockExpiresAt) {
                              const timeLeft = this.getTimeUntil(reqStatus.unlockExpiresAt);
                              if (timeLeft !== "expired") {
                                return (
                                  <span className="access-badge access-badge-approved-inline">
                                    Temp access (expires in {timeLeft})
                                  </span>
                                );
                              }
                            }
                            return null;
                          })()}
                        </span>
                      </div>
                      {this.state.lockedStepIds.has(step.id) && (
                        <div className="col col-auto align-self-center" style={{ paddingLeft: 4 }}>
                          {(() => {
                            const reqStatus = this.state.accessRequestStatuses.get(step.id);

                            // No request exists yet - show original Request Access button
                            if (!reqStatus) {
                              return (
                                <button
                                  className="btn-request-access"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    this.setState({
                                      showAccessRequestModal: true,
                                      accessRequestStep: step,
                                      accessRequestReason: "",
                                    });
                                  }}
                                  title="Request temporary access to edit this step"
                                >
                                  Request Access
                                </button>
                              );
                            }

                            // PENDING
                            if (reqStatus.status === "PENDING") {
                              return (
                                <span className="access-badge access-badge-pending" title={`Requested ${this.getRelativeTime(reqStatus.requestedAt)}`}>
                                  Access Requested
                                  <span className="access-badge-time">{this.getRelativeTime(reqStatus.requestedAt)}</span>
                                </span>
                              );
                            }

                            // APPROVED but expired (if active, step wouldn't be in lockedStepIds)
                            if (reqStatus.status === "APPROVED") {
                              return (
                                <button
                                  className="btn-request-access"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    this.setState({
                                      showAccessRequestModal: true,
                                      accessRequestStep: step,
                                      accessRequestReason: "",
                                    });
                                  }}
                                  title="Previous access has expired. Request again."
                                >
                                  Re-request Access
                                </button>
                              );
                            }

                            // REJECTED
                            if (reqStatus.status === "REJECTED") {
                              return (
                                <div className="access-rejected-group" onClick={(e) => e.stopPropagation()}>
                                  <span className="access-badge access-badge-rejected" title={reqStatus.reviewRemarks || "Request was denied"}>
                                    Request Denied
                                  </span>
                                  {reqStatus.reviewRemarks && (
                                    <span className="access-badge-remarks" title={reqStatus.reviewRemarks}>
                                      {reqStatus.reviewRemarks.length > 20 ? reqStatus.reviewRemarks.substring(0, 20) + "..." : reqStatus.reviewRemarks}
                                    </span>
                                  )}
                                  <button
                                    className="btn-request-access btn-request-access-sm"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      this.setState({
                                        showAccessRequestModal: true,
                                        accessRequestStep: step,
                                        accessRequestReason: "",
                                      });
                                    }}
                                    title="Submit a new access request"
                                  >
                                    Re-request
                                  </button>
                                </div>
                              );
                            }

                            // Fallback
                            return (
                              <button
                                className="btn-request-access"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.setState({
                                    showAccessRequestModal: true,
                                    accessRequestStep: step,
                                    accessRequestReason: "",
                                  });
                                }}
                              >
                                Request Access
                              </button>
                            );
                          })()}
                        </div>
                      )}
                      <div className="col col-auto align-self-center align-items-center">
                        <FontAwesomeIcon
                          icon={faCaretDown}
                          onClick={() => this.more(step)}
                          className="float-right"
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.loading && <PageSpinner />}

        <Modal show={this.state.showStatusEditModal}>
          <Modal.Header closeButton onHide={() => this.setState({ showStatusEditModal: false })}>
            <Modal.Title id="modal-step-status-edit-title">
              Edit Step Status
            </Modal.Title>
          </Modal.Header>
          <div className="modal-body">
            {this.state.lockedStepIds.has(this.state.editLessonPlanStep?.id) && (
              <div className="alert alert-warning" style={{ marginBottom: '1rem' }}>
                This step is locked because its planned end date has passed.
                Request temporary access to make changes.
              </div>
            )}
            {this.state.statusTypes.map((statusType) => (
              <div className="custom-control custom-radio" key={statusType.id}>
                <input
                  type="radio"
                  className="custom-control-input"
                  id={`status-${statusType.id}`}
                  name="statusRadios"
                  defaultChecked={
                    this.state.editLessonPlanStepStatus === statusType.id
                  }
                  onClick={() => this.setState({ editLessonPlanStepStatus: statusType.id })}
                />
                <label className="custom-control-label" htmlFor={`status-${statusType.id}`}>
                  {statusType.name}
                </label>
              </div>
            ))}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => this.setState({ showStatusEditModal: false })}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                this.editLessonplanStatus(
                  this.state.editLessonPlanStep,
                  this.state.editLessonPlanStepStatus
                );
                this.setState({
                  showStatusEditModal: false,
                  StatusEditModalClicked: true,
                });
              }}
            >
              Save
            </button>
          </div>
        </Modal>

        <Modal show={this.state.showMoreOptions}>
          <Modal.Header closeButton onHide={() => this.setState({ showMoreOptions: false })}>
            <Modal.Title id="modal-more-options-title">
              More Options
            </Modal.Title>
          </Modal.Header>
          <div className="modal-body">
            {this.state.moreOptions.length > 0 && (
              <div className="custom-control custom-radio">
                <MDBInput
                  type="radio"
                  class="custom-control-input"
                  id="moreOptions"
                  name="moreOptions"
                  // [attr.checked]="moreOptions.length>0 ? '' : null"
                />
                <label className="custom-control-label" htmlFor="moreOptions">
                  {this.state.moreOptions.length > 0
                    ? this.state.moreOptions[0].displayName
                    : "Start Quiz"}
                </label>
              </div>
            )}
            {this.state.moreOptions.length <= 0 && (
              <div className="custom-control">
                <b>No Quiz found.</b>
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => this.setState({ showMoreOptions: false })}
            >
              Cancel
            </button>
            {this.state.moreOptions.length > 0 && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={() =>
                  this.setState({
                    showMoreOptions: false,
                    MoreOptionsClicked: true,
                  })
                }
              >
                Proceed
              </button>
            )}
          </div>
        </Modal>

        {/* Step Analytics Modal */}
        <StepAnalyticsModal
          show={this.state.showAnalyticsModal}
          onClose={this.closeAnalyticsModal}
          step={this.state.selectedAnalyticsStep}
          lessonPlanId={this.state.lessonplanDetails?.lessonplanId || 0}
          batchId={this.state.lessonplanDetails?.batchId || 0}
        />

        {/* Resource Activation Results Modal */}
        <Modal
          show={this.state.showResourceActivationModal}
          onHide={() => this.setState({ showResourceActivationModal: false })}
          size="lg"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ color: 'var(--status-success)' }}>
              ✓ Resources for Students
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.activationResults && (
              <div>
                <div style={{ marginBottom: '1.5rem', padding: '1rem', backgroundColor: 'var(--surface-page)', borderRadius: '8px' }}>
                  <h5 style={{ marginBottom: '0.5rem', color: 'var(--text-strong)' }}>
                    {this.state.activationResults.stepName}
                  </h5>
                  <p style={{ margin: 0, color: 'var(--text-muted)', fontSize: '0.95rem' }}>
                    Status changed to: <strong>{this.state.activationResults.statusName}</strong>
                  </p>
                  <p style={{ margin: '0.5rem 0 0 0', color: 'var(--status-success)', fontWeight: 600 }}>
                    {this.state.activationResults.totalAssignments} resource{this.state.activationResults.totalAssignments !== 1 ? 's' : ''} available for students
                  </p>
                </div>

                <h6 style={{ marginBottom: '1rem', color: 'var(--text-body)' }}>Resources &amp; Tests for this Step:</h6>
                <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                  {/* Group resources by tag label */}
                  {Object.entries(
                    this.state.activationResults.resourceDetails.reduce((acc: any, resource: any) => {
                      const tagLabel = resource.tagLabel || 'General';
                      if (!acc[tagLabel]) acc[tagLabel] = [];
                      acc[tagLabel].push(resource);
                      return acc;
                    }, {})
                  ).map(([tagLabel, resources]: [string, any]) => (
                    <div key={tagLabel} style={{ marginBottom: '1.5rem' }}>
                      <div style={{
                        backgroundColor: 'var(--brand-primary)',
                        color: 'white',
                        padding: '0.5rem 1rem',
                        borderRadius: '6px',
                        fontWeight: 600,
                        marginBottom: '0.75rem',
                        fontSize: '0.9rem'
                      }}>
                        {tagLabel} ({resources.length})
                      </div>
                      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                        {resources.map((resource: any, idx: number) => (
                          <li
                            key={resource.id}
                            style={{
                              padding: '0.75rem 1rem',
                              marginBottom: '0.5rem',
                              backgroundColor: idx % 2 === 0 ? '#f9fafb' : '#ffffff',
                              borderLeft: '3px solid var(--brand-primary)',
                              borderRadius: '4px',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '0.75rem'
                            }}
                          >
                            <span style={{ fontSize: '1.25rem' }}>{resource.type === 'test' ? '📋' : getResourceIcon(resource.typeId, resource.url, resource.name)}</span>
                            <span style={{ flex: 1, color: 'var(--text-strong)' }}>{resource.name}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-success"
              onClick={() => this.setState({ showResourceActivationModal: false })}
            >
              OK
            </button>
          </Modal.Footer>
        </Modal>

        {/* LCS Access Request Modal */}
        <Modal
          show={this.state.showAccessRequestModal}
          onHide={() => this.setState({ showAccessRequestModal: false })}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Request Temporary Access</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.accessRequestStep && (
              <div>
                <p><strong>Step:</strong> {this.state.accessRequestStep.name}</p>
                <p><strong>Planned End Date:</strong> {this.state.accessRequestStep.lcsLock?.plannedEndDate || this.state.accessRequestStep.endDate || "N/A"}</p>
                <div className="form-group" style={{ marginTop: '1rem' }}>
                  <label htmlFor="accessReason">Reason for requesting access:</label>
                  <textarea
                    id="accessReason"
                    className="form-control"
                    rows={3}
                    value={this.state.accessRequestReason}
                    onChange={(e) => this.setState({ accessRequestReason: e.target.value })}
                    placeholder="Please explain why you need to update this step..."
                  />
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-secondary"
              onClick={() => this.setState({ showAccessRequestModal: false })}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={this.submitAccessRequest}
            >
              Submit Request
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
